export default __webpack_public_path__ + "static/media/626.60ca81d1.png";